(() => {
  if (window.ErgoProductQuoteInitialized) return;
  window.ErgoProductQuoteInitialized = true;

  const pendingKey = 'ergo-product-quote-pending';

  const showQuoteModal = (modal) => {
    if (!modal) return;

    window.customElements
      .whenDefined('modal-box')
      .then(() => modal.show());
  };

  const getPendingForm = () => {
    try {
      return window.sessionStorage.getItem(pendingKey);
    } catch (error) {
      return null;
    }
  };

  const savePendingForm = (formId) => {
    try {
      window.sessionStorage.setItem(pendingKey, formId);
    } catch (error) {
      // The form will still submit if browser storage is unavailable.
    }
  };

  const clearPendingForm = () => {
    try {
      window.sessionStorage.removeItem(pendingKey);
    } catch (error) {
      // No action required.
    }
  };

  const clearQuoteStatusFromUrl = (formId) => {
    try {
      const url = new URL(window.location.href);

      url.searchParams.delete('contact_posted');

      if (url.hash === `#${formId}`) {
        url.hash = '';
      }

      window.history.replaceState(
        window.history.state,
        '',
        `${url.pathname}${url.search}${url.hash}`
      );
    } catch (error) {
      // No action required.
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-quote-modal-open]');
    if (!trigger) return;

    event.preventDefault();

    const modal = document.getElementById(
      trigger.dataset.quoteModalOpen
    );

    showQuoteModal(modal);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;

    if (!form.matches('.quote-form')) return;

    savePendingForm(form.id);
  });

  const handleQuoteResult = () => {
    document
      .querySelectorAll('[data-quote-open-on-load]')
      .forEach((status) => {
        const form = status.closest('form');
        const modal = status.closest('modal-box');

        if (!form) return;

        const pendingForm = getPendingForm();

        if (pendingForm === form.id) {
          showQuoteModal(modal);
          clearPendingForm();
        }

        clearQuoteStatusFromUrl(form.id);
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      handleQuoteResult
    );
  } else {
    handleQuoteResult();
  }
})();